import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error';
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div style={{
      position: 'fixed',
      bottom: 'var(--spacing-xl)',
      left: '50%',
      transform: 'translateX(-50%)',
      background: type === 'success' ? 'var(--status-green)' : 'var(--status-red)',
      color: 'var(--bg-primary)',
      padding: 'var(--spacing-md) var(--spacing-xl)',
      borderRadius: 'var(--radius-md)',
      fontWeight: 700,
      boxShadow: 'var(--shadow-md)',
      zIndex: 1000,
      fontSize: '0.9rem'
    }}>
      {message}
    </div>
  );
};

export default Toast;
